import { isString, lowerCase, reverseString } from '../../../utils';
import { DIGIT_REG_EX, DOUBLE_BYTE_REG_EX, FOUR_CHAR_SEQUENCES, FOUR_REPEATED_REG_EX, NON_VALID_CHARS_REG_EX, NON_VALID_SYMBOL_REG_EX, SYMBOL_REG_EX } from './constants';

var containsFourCharSequence = value => {
  var testValue = "".concat(value, " ").concat(reverseString(value));

  for (var i = 0; i < testValue.length - 3; i++) {
    if (FOUR_CHAR_SEQUENCES.includes(testValue.substr(i, 4))) {
      return true;
    }
  }

  return false;
};

var violatesInfoSecRequirements = (value, countryCode, user) => {
  if (!isString(value) || !isString(countryCode)) {
    return true;
  }

  if (!value.length || countryCode !== 'AU') {
    return false;
  }

  var lowerCasePasswordValue = value.toLowerCase();
  return Object.values(user).filter(s => s === null || s === void 0 ? void 0 : s.length).map(lowerCase).some(s => lowerCasePasswordValue.includes(s));
};

var validatePassword = function validatePassword(value) {
  var {
    props = {}
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var {
    countryCode = '',
    user = {}
  } = props;
  var len = value.length;
  var isPresent = Boolean(len);
  var result = {
    hasDoubleByte: DOUBLE_BYTE_REG_EX.test(value),
    hasFourCharRepeated: len > 3 && FOUR_REPEATED_REG_EX.test(value),
    hasFourCharSequence: len > 3 && containsFourCharSequence(value),
    hasNonValidChars: NON_VALID_CHARS_REG_EX.test(value),
    hasNonValidSymbol: NON_VALID_SYMBOL_REG_EX.test(value),
    infoSecViolation: violatesInfoSecRequirements(value, countryCode, user),
    missingNumberOrSymbol: !DIGIT_REG_EX.test(value) && !SYMBOL_REG_EX.test(value),
    tooLong: len > 20,
    tooShort: len < 8,
    valueMissing: !isPresent
  };
  result.errors = Object.keys(result).filter(key => result[key]);
  result.isValid = !result.errors.length;
  return result;
};

export { validatePassword, containsFourCharSequence, violatesInfoSecRequirements };